import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

/** Plays a cancel-flow vet video in a lightbox; the iframe unloads on close to stop playback. */
export default class extends Controller {
  static targets = ['modal', 'frame', 'poster'];
  static values = { src: String, playUrl: String, key: String };

  /** Listens directly, because a Stimulus action reads the dots in "hidden.bs.modal" as a key filter. */
  connect() {
    this.stop = this.stop.bind(this);
    this.modalTarget.addEventListener('hidden.bs.modal', this.stop);
  }

  disconnect() {
    this.modalTarget.removeEventListener('hidden.bs.modal', this.stop);
  }

  open() {
    this.frameTarget.src = this.srcValue;
    Modal.getOrCreateInstance(this.modalTarget).show();
    this.recordPlay();
  }

  /** Refocuses the poster, because Bootstrap restores focus only for a data-bs-toggle opener. */
  stop() {
    this.frameTarget.removeAttribute('src');
    this.posterTarget.focus();
  }

  /** Posts the play to the server, which sends cancel_video_played with the funnel's properties. */
  recordPlay() {
    if (!this.hasPlayUrlValue) return;

    const body = new FormData();
    body.append('video', this.keyValue);

    fetch(this.playUrlValue, {
      method: 'POST',
      keepalive: true,
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: 'application/json',
      },
      body,
    }).catch(() => {});
  }
}
